import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import MentalHealthAndYouPage from '@/components/pages/faq/mentalHealthAndYou';

const ProtectedMentalHealthAndYouPage = withAuthenticationRequired(
  MentalHealthAndYouPage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/faq/documents/mentalHealthAndYou')({
  head: () => ({
    meta: [{ title: `Mental Health & You | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedMentalHealthAndYouPage,
});
